var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"center"},[_c('p',{staticClass:"h1"},[_vm._v("专业的商业大数据解决方案供应商")]),_vm._v(" "),_c('p',{staticClass:"h3"},[_vm._v("数量化追踪，预测，数据审计")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.showDetail}},[_vm._v("开始使用")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15137e7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = null
// module chunks = 